import { redirect } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { PublicNav } from "@/components/site/PublicNav";
import { Footer } from "@/components/site/Footer";
import { SocialFeed } from "@/components/social/SocialFeed";
import { ProfileSearch } from "@/components/social/ProfileSearch";
import { AskShieldsChat } from "@/components/chat/AskShieldsChat";

export const Route = createFileRoute("/community")({
  // Retired marketplace screen: hidden from visitors, data kept.
  beforeLoad: () => { throw redirect({ to: "/guides" }); },
  head: () => ({
    meta: [
      { title: "Shields Community — people, jobs and before-and-afters" },
      {
        name: "description",
        content:
          "Follow verified Shields partners and customers, see real finished jobs, and search profiles by trade, area or @username.",
      },
      { property: "og:title", content: "Shields Community — people, jobs and before-and-afters" },
      {
        property: "og:description",
        content: "Follow partners and customers, browse finished work and find people near you.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: CommunityPage,
});

function CommunityPage() {
  return (
    <div className="min-h-screen">
      <PublicNav />
      <main className="section-pad mx-auto max-w-6xl py-12">
        <h1 className="font-display text-3xl font-extrabold sm:text-4xl">Shields Community</h1>
        <p className="mt-3 max-w-2xl text-muted-foreground">
          Real jobs, real people. Follow the partners and neighbours you like, and ask Shields AI
          anything at any point.
        </p>

        <div className="mt-10 grid gap-10 lg:grid-cols-[minmax(0,1fr)_360px]">
          <div className="min-w-0 space-y-12">
            <SocialFeed heading="Latest from the community" />
            <ProfileSearch />
          </div>
          <aside className="min-w-0 space-y-6 lg:sticky lg:top-24 lg:self-start">
            <AskShieldsChat compact />
          </aside>
        </div>
      </main>
      <Footer />
    </div>
  );
}
